import { useCartValues } from '../../providers/CartProvider';
import * as StyledShared from '../../styles';

export const CartBack = () => {
  const { goBack } = useCartValues();
  return <StyledShared.BackIcon onClick={goBack} />;
};
